import { render, staticRenderFns } from "./FormAddCliente.vue?vue&type=template&id=70c287ba&"
import script from "./FormAddCliente.vue?vue&type=script&lang=js&"
export * from "./FormAddCliente.vue?vue&type=script&lang=js&"
import style0 from "./FormAddCliente.vue?vue&type=style&index=0&id=70c287ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports